/**
 * ReportViewToggle — Resumo × Detalhado.
 *
 * **Resumo** é o agregado de sempre. **Detalhado** mostra a lista COMPLETA, sem
 * trocar de tela — e é o que resolve uma dívida real: as listas dos relatórios
 * cortavam em top 5 / `LIST_LIMIT = 8` com um "+N" que empurrava o usuário para
 * a exportação. Corte é aceitável num resumo; num relatório sem saída, não.
 *
 * Por que NÃO é um `<Tabs>`: o alternador de abas do app é a pill AZUL
 * (CLAUDE.md #25) e já está logo acima, escolhendo QUAL relatório. Um segundo
 * conjunto de pills azuis na linha de baixo pareceria mais abas. Este é um
 * `radiogroup` de verdade (é o que o concorrente usa), neutro, com o ativo em
 * `bg-background` — nem azul de aba, nem verde de ação.
 */
import { cn } from '@/lib/utils';

export type ReportViewMode = 'summary' | 'detailed';

export const REPORT_VIEW_LABELS: Record<ReportViewMode, string> = {
  summary: 'Resumo',
  detailed: 'Detalhado',
};

interface ReportViewToggleProps {
  value: ReportViewMode;
  onChange: (mode: ReportViewMode) => void;
  /** Linha de ajuda à direita (ex.: "12 itens"). */
  hint?: string;
  className?: string;
}

export function ReportViewToggle({ value, onChange, hint, className }: ReportViewToggleProps) {
  return (
    <div className={cn('flex items-center justify-between gap-3', className)}>
      <div
        role="radiogroup"
        aria-label="Nível de detalhe do relatório"
        className="inline-flex items-center rounded-full bg-muted p-0.5"
      >
        {(Object.keys(REPORT_VIEW_LABELS) as ReportViewMode[]).map((mode) => (
          <button
            key={mode}
            type="button"
            role="radio"
            aria-checked={value === mode}
            onClick={() => onChange(mode)}
            className={cn(
              'rounded-full px-3 py-1 text-xs font-medium transition-colors',
              value === mode
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {REPORT_VIEW_LABELS[mode]}
          </button>
        ))}
      </div>
      {hint ? (
        <span className="truncate text-[11px] text-muted-foreground">{hint}</span>
      ) : null}
    </div>
  );
}

/**
 * Quantos itens mostrar. No modo detalhado NÃO há corte — é o ponto do modo.
 * O teto alto existe só para uma lista patológica não travar o WebView; se ele
 * for atingido, quem chama avisa na tela (nunca corta calado).
 */
export const DETAILED_HARD_LIMIT = 500;

export function listLimitFor(mode: ReportViewMode, summaryLimit: number): number {
  return mode === 'detailed' ? DETAILED_HARD_LIMIT : summaryLimit;
}
